export const SIDEBAR_WIDTH = ["100%", "180px", "240px"];

export const FALLBACK_MAP_VIEWSTATE = {
  longitude: -4.51,
  latitude: 54.84,
  zoom: 4,
};
